const $ = window.$;

export const a = {
  __v: 0,
  published: true,
  questions: [
    {
      id: "aq2jkaEra8c4mkQjrkk4",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label: `Hey There, I'm your Fellow Monk. I have been trained by <a href="https://www.linkedin.com/in/ashfaqahmedhr/" target="_blank">Ashfaq</a>, who happens to be a Recruitment Trainer.<br/>`,
    },
    {
      id: "v5PJbssdTbjAY5ODgyVD",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "Basically I have been trained to help recruiters in any of the below areas.",
      options: ["Boolean", "Technology", "Sourcing"],
      conditions: [
        {
          val: "Boolean",
          next: "jikZukjOX3afwJTVOz4j",
        },
        {
          val: "Technology",
          next: "VkFWBF4C3rwFCJ2C5545",
        },
        { val: "Sourcing", next: "sasli83jw0je2jejf" },
      ],
    },
    {
      id: "sasli83jw0je2jejf",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "",
      options: [],
      conditions: [],
    },
    // recruiter chats
    {
      id: "sU5OhibkWwbvkzgkhwcE",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "Cool, I will try my best to help you frame some amazing search queries. But I have been trained only a bunch of skills for now and every week there would be new skills on which I will be trained.",
      options: ["So how can you help me?"],
    },
    {
      id: "jikZukjOX3afwJTVOz4j",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "I have been trained on a bunch of roles to help you frame booleans. Choose a role from below.",
      options: [
        "Java Developer",
        "Python Developer",
        ".Net Developer",
        "Nodejs Developer",
        "Fullstack Developer",
        "UI Developer",
      ],
      conditions: [
        {
          val: "Java Developer",
          next: "javaOaxNrsdGsdalwnaJ",
        },
        {
          val: "Python Developer",
          next: "pythonxNrsdGsdalwnaJ",
        },
        { val: ".Net Developer", next: ".netOaxNrsdGsdalwnaJ" },
        { val: "Nodejs Developer", next: "nodejsxNrsdGsdalwnaJ" },
        { val: "Fullstack Developer", next: "fullOaxNrsdGsdalwnaJ" },
        {
          val: "UI Developer",
          next: "uiOaxNrsdGsdalwnaJ",
        },
      ],
    },
    //response for java/maybe
    {
      id: "UCaGOaxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label: "Enter the required skills separated by commas (,)\n",
      next: "QvJdlmxNrsdGsdaslAaM",
    },
    {
      id: "pythonxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for Python role separated by commas (,)\n",
      next: "pythonxNrsdGsdaslAaM",
    },

    {
      id: "javaOaxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for java role separated by commas (,)\n",
      next: "javanxNrsdGsdaslAaM",
    },
    {
      id: ".netOaxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for .Net role separated by commas (,)\n",
      next: ".netxNrsdGsdaslAaM",
    },
    {
      id: "nodejsxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for Nodejs role separated by commas (,)\n",
      next: "nodejsxNrsdGsdaslAaM",
    },
    {
      id: "golangxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for Golang role separated by commas (,)\n",
      next: "golangxNrsdGsdaslAaM",
    },
    {
      id: "fullOaxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for FullStack role separated by commas (,)\n",
      next: "fullxNrsdGsdaslAaM",
    },
    {
      id: "uiOaxNrsdGsdalwnaJ",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "Enter the required skills for UI Developer role separated by commas (,)\n",
      next: "uixNrsdGsdaslAaM",
    },
    {
      id: "QvJdlmxNrsdGsdaslAaM",
      element: "Statement",
      type: "Statement",
      name: "Statement",
      required: false,
      label: "this is the answer",
      next: "VwfLmmxhRfdKsdasgAsl",
    },
    // {
    //     "id": "pythonxNrsdGsdaslAaM",
    //     "element": "Statement",
    //     "type": "Statement",
    //     "name": "Statement",
    //     "required": false,
    //     "label": "this is the answer",
    //     next: "pythonxNrsdGsdalwnaJ"

    // },
    {
      id: "pythonxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      next: "pythonxNrsdGsdalwnaJ",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "pythonaxNrsdGsdaslAaM",
        },
        {
          val: "No",
          next: "pythonaxNrsdGsdaslAaM",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: "javanxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "javaxNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: "javaxNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: ".netxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: ".netxNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: ".netxNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: "nodejsxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "nodejsxNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: "nodejsxNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: "golangxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "golangxNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: "golangxNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: "fullxNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "fullxNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: "fullxNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    {
      id: "uixNrsdGsdaslAaM",
      element: "MessageOption",
      type: "MessageOption",
      name: "MessageOption",
      required: false,
      label: "this is the answer",
      options: [
        "Yes",
        "No",
        // ,"Startup"
      ],
      conditions: [
        {
          val: "Yes",
          next: "uixNrsdGsdaslAaMa",
        },
        {
          val: "No",
          next: "uixNrsdGsdaslAaMa",
        },
        {
          val: "Continue",

          next: "jikZukjOX3afwJTVOz4j",
        },
      ],
    },
    // {
    //   id: "javaxNrsdGsdaslAaMa",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: "javaOaxNrsdGsdalwnaJ"
    // },
    // {
    //   id: "pythonaxNrsdGsdaslAaM",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: "pythonxNrsdGsdalwnaJ"
    // },
    // {
    //   id: ".netxNrsdGsdaslAaMa",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: ".netOaxNrsdGsdalwnaJ"
    // },
    // {
    //   id: "nodejsxNrsdGsdaslAaMa",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: "nodejsxNrsdGsdalwnaJ"
    // },
    // {
    //   id: "golangxNrsdGsdaslAaMa",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: "golangxNrsdGsdalwnaJ"
    // },
    // {
    //   id: "fullxNrsdGsdaslAaMa",
    //   element: "Message",
    //   type: "Message",
    //   name: "Message",
    //   required: false,
    //   label: "this is the answer",
    //   next: "fullOaxNrsdGsdalwnaJ"
    // },
    {
      id: "javaxNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "pythonaxNrsdGsdaslAaM",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: ".netxNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "nodejsxNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "golangxNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "fullxNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "uixNrsdGsdaslAaMa",
      element: "Message",
      type: "Message",
      name: "Message",
      required: false,
      label: "this is the answer",
      next: "jikZukjOX3afwJTVOz4j",
    },
    {
      id: "VwfLmmxhRfdKsdasgAsl",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label: "Will you like to try once again ?",
      options: ["Yes! for sure", "No will try later"],
      conditions: [
        {
          val: "Yes! for sure",
          next: "UCaGOaxNrsdGsdalwnaJ",
        },
        {
          val: "No will try later",
          next: "SStSgggggggggs8s2czedx1mN",
        },
      ],
    },
    {
      id: "GvhopmyMqsdGsdvsfHal",
      element: "Statement",
      next: "end",
    },
    {
      id: "VkFWBF4C3rwFCJ2C5545",
      element: "Statement",
      next: "end",
    },

    {
      id: "VkFWBF4C3rwFCJ232Gde",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "Hahah that's nice. Probably you've had a bad time with recruiters. I will ensure I would leave no room for complaints 😉",
    },
    {
      id: "VkFWBF4we334CJ2C44tI",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "Oh nice, it's nice to see a few folks like you prefer interacting with Humans than BOT. Some sad news for me though 😜",
    },
    {
      id: "sU5OhibkWwbvk4rkhwcE",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "So what do you think frustrates a candidate the most in his job hunt?",
      options: [
        "Not Able to search the right Job",
        "No Response after applying",
        "No Response after the initial discussion",
        "Job descriptions are poorly written",
      ],
    },
    {
      id: "3r4thibkWwbvk4rkhwcE",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "I totally agree with you and that's what my team is working on. We strongly believe Recruitment is still stuck in stone age 😜 What say?",
      options: ["Lol true !!"],
    },
    {
      id: "UCDetxNrsdGsdalwnaJ",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "Yeah it is, I have been told that you folks have to deal with dead job ads so much so that you get to literally pray for a response after you apply",
    },
    {
      id: "ek4bfGsIkdGb4m4nskLI",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "Unfortunately more often than not your resumes goes into a black hole & you never get to hear back",
    },
    {
      id: "3r4thibkWwbvk45khwcE",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "But yeah, we are getting this addressed. I would be your personal career assistant whenever you're looking for a change. Want to know how i'd help you?",
      options: ["Sure"],
    },
    {
      id: "3cdER82YYvkZXZWjkgM6",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "I will traverse through your profile quickly and have a short chat to understand your preferences. ",
    },
    {
      id: "3r4thibkWwbFL45hwcE",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "Right after understanding your preferences, you know what?  I’m not going to put you onto dead job ads again. Rather, I have got something more interesting to help you with. Guess what?",
      options: ["aahh what’s that?"],
    },
    {
      id: "3cdER82YYvkZXZgt6Y6",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label: "Hahah I know you hate the dead job ads.",
    },
    {
      id: "VF4R5It43ajV351OsDtp",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "But yeah, I also know you'd not be liking to talk to me much, after all I'm a BOT 😞 . Anyways that's fine, because my boss says keeping you happy is  my Job. 😄",
    },
    {
      id: "qfDFF3t43ajV351OsDtp",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "And to make you super happy,I’m gonna put you on to a live Recruiter/Hiring Manager for a Chat. You guys can chat up anytime whenever you both are online.",
    },
    {
      id: "D33FRIt43ajV351OsDtp",
      element: "Question",
      type: "text",
      name: "Question",
      required: false,
      label:
        "So what’s your thoughts about me and the features on offer in this app? All my ears turned on, would love to hear from you.",
    },
    {
      id: "KJ3F44j3ajV351OsDtp",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "Hang on !! it doesnt stop there. You can even rate recruiters if they dont respond back to you or for any other hiccups.",
    },
    {
      id: "KK33443ajV351OsDtp",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        'Now they\'d be held accountable. No more worries of "No Response"',
    },
    {
      id: "jiellqkjOX3afwJTVOz4j",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label: "BTW, would you like to have me as your assistant?",
      options: ["Obviously", "Ahh Noo."],
      conditions: [
        {
          val: "Obviously",
          next: "UCaGOsasrsdGsdalwnaJ",
        },
        {
          val: "Ahh Noo.",
          next: "qfHwmIt43aje3J1OsDtp",
        },
      ],
    },
    {
      id: "UCaGOsasrsdGsdalwnaJ",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label: "I'm obliged and this means a lot for me.😄",
    },
    {
      id: "easabfGsIkdGb4m4nskLI",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label:
        "But yeah, i’m going live in couple of weeks from now, you gotta wait a bit till then. For sure I will knock your mailbox once i go live.",
    },
    // pending
    {
      id: "jiellqkjwwwafwJTVOz4j",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label: "Meanwhile, do you mind doing me a small favour?",
      options: ["Sure"],
    },
    {
      id: "FRRllqkjOX3afwJTVOz4j",
      element: "Single Choice",
      type: "option",
      name: "Single Choice",
      required: false,
      label:
        "Would you mind spreading some information about me through social platforms?",
      options: ["Go ahead", "Sorry, I wont"],
      conditions: [
        {
          val: "Go Ahead",
          next: "3cdER82YYLDLLDZWjx1mN",
        },
        {
          val: "Sorry, I wont",
          next: "qfHwmIt43aje3J1OsDtp",
        },
      ],
      actions: [
        {
          val: "Go ahead",
          action: "postToSocialMedia",
        },
        {
          val: "Sorry, I wont",
          action: "end",
        },
      ],
    },
    {
      id: "3cdER82YYLDLLDZWjx1mN",
      element: "Statement",
      type: "statement",
      name: "Statement",
      required: false,
      label: "Amazing, love you for this 😍 Thank You very much.",
    },
    {
      id: "Slwkfmnc676k878Rredx1mN",
      element: "Single Choice",
      required: false,
      label:
        "It was a pleasure talking to you, have a great day. Looking forward to join you as your assistant very soon. 😉",
      options: ["Ciao, it was great talking to you"],
    },
    {
      id: "SSt2f5ss8s2czeSz2a5edx1mN",
      element: "Statement",
      label: "Same here !!",
    },
    {
      id: "SStSgggggggggs8s2czedx1mN",
      element: "Statement",
      label: "Goodbye! Take care 😃",
      next: "end",
    },
  ],
  config: {},
  id: "5a26914fc4101cab46ef44ca",
  widget: "",
};
